module.exports = __webpack_public_path__ + "img/10blue.1e849a23.png";